import React from "react";

const VerifiedIcon = ({ size = 18, color = "#2e7d32" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="11" fill={color} />
    <path
      d="M6.5 11.2l3.1 3.1 5.9-6.2"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VerifiedFreightTag = ({ verifiedFreight, style }) => {
  if (!verifiedFreight) return null;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: "#e8f5e9",
        border: "1px solid #a5d6a7",
        color: "#1b5e20",
        fontSize: 12,
        fontWeight: 700,
        padding: "4px 12px 4px 5px",
        borderRadius: 999,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      <VerifiedIcon size={18} color="#2e7d32" />
      Verified Freight
    </span>
  );
};

export default VerifiedFreightTag;